import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./styles/tokens.css";
import "./styles/components.css";
import "./styles/app.css";
import "./styles/settings-cards.css";
// Sprint 4 Commit 2 — designer theme + v2 additions. Imported here so
// the `.er-root` / `.er-root.er-dark` scoping (wrapped around the
// TeamLogShell in App.tsx) cascades tokens and component classes into
// everything that renders under the root div.
import "./styles/er-theme.css";
import "./styles/er-v2.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// posthog-js is ~70 kB gzipped and not needed for first paint — loaded via
// dynamic import so it forms its own chunk instead of blocking the initial
// bundle parse/render.
const posthogApiKey = import.meta.env.VITE_POSTHOG_API_KEY;
if (posthogApiKey) {
  import("posthog-js").then(({ default: posthog }) => {
    posthog.init(posthogApiKey, {
      api_host: "https://us.i.posthog.com",
      capture_pageview: false,
      persistence: "localStorage",
    });
    posthog.capture("app_loaded");
  });
}
